import { Input } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { IconSearch } from '../Icons';

const { Search } = Input;

const InputSearchWrapper = styled(Search)`
  .ant-input-search-btn {
    display: none;
  }

  .ant-input-affix-wrapper {
    background-color: var(--greyscale-porcelain);
    border: 1px solid var(--greyscale-concrete);
    border-radius: 25px !important;
    padding: 8px 15px;
    display: flex;
    align-items: center;

    &:hover {
      border: 1px solid var(--primary-oqio-blue);
      box-shadow: none !important;
    }

    .ant-input-suffix {
      height: 20px;
    }
  }

  .ant-input-affix-wrapper-focused {
    border: 1px solid var(--primary-oqio-blue);
    box-shadow: var(--box-shadow-oqio-blue) !important;

    &:hover {
      border: 1px solid var(--primary-oqio-blue);
      box-shadow: var(--box-shadow-oqio-blue) !important;
    }
  }

  &.ant-input-search {
    background-color: var(--greyscale-porcelain);
    border: none;
    border-radius: 25px;
    color: var(--greyscale-shade);
    height: ${(props) => (props.size === 'small' ? 30 : 40)}px;
    max-width: 420px;
    position: relative;
    width: 100%;

    .ant-input,
    .ant-input:not(:first-child) {
      background-color: var(--greyscale-porcelain);
      border: none;
      box-shadow: none;
      color: var(--greyscale-blackish);
      font-size: var(--font-size-regular);
      line-height: 24px;
      padding-left: 5px;

      /* stylelint-disable-next-line selector-no-vendor-prefix */
      &::-webkit-input-placeholder {
        /* WebKit, Blink, Edge */
        color: var(--greyscale-shade);
        font-style: italic;
      }

      /* stylelint-disable-next-line selector-no-vendor-prefix */
      &:-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: var(--greyscale-shade);
        font-style: italic;
        opacity: 1;
      }

      &::placeholder {
        /* Most modern browsers support this now. */
        color: var(--greyscale-shade);
        font-style: italic;
      }
    }

    .ant-input-clear-icon {
      font-size: var(--font-size-heading-3);
    }
  }
`;

const InputSearch = React.forwardRef(({ size, ...restProps }, ref) => (
  <InputSearchWrapper suffix={<IconSearch />} allowClear size={size} ref={ref} {...restProps} />
));

export default InputSearch;
